import axios from "axios";
import { getAuthHeaders, perPage } from "../helpers";

/**
 * @function getReferralsList
 * @desc this function will get list of referrals
 */
export const getReferralsList = pageNo => {
  const url = `${process.env.REACT_APP_SERVER_URL}/referrals?page=${pageNo}&perpage=${perPage}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getReferralDetail
 * @desc this function will get list of referrals
 */
export const getReferralDetails = referralId => {
  const url = `${process.env.REACT_APP_SERVER_URL}/referrals/${referralId}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

export const bookAppointmentForReferral = appointmentObj => {
  return axios.post(
    `${process.env.REACT_APP_SERVER_URL}/referrals/${appointmentObj.referralId}/book_appointment`,
    {
      clinic_doctor_id: appointmentObj.clinic_doctor_id,
      discount_schedule_id: appointmentObj.discount_schedule_id,
      appointment_date: appointmentObj.appointment_date
    },
    {
      headers: getAuthHeaders()
    }
  );
};
